import React from "react";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import Table from "examples/Tables/Table";
import ArgonButton from "components/ArgonButton";
import TimeSlotTableData from "Views/Curriculum/data/timeSlotTableData";
import { useState } from "react";
import DeleteDialog from "components/DeleteDialog/DeleteDialog";
import axios from "utils/api";
import { baseURL } from "utils/api";
import { toast } from "react-toastify";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Divider,
} from "@mui/material";
import { Close } from "@mui/icons-material";

function index() {
  const [refresh, setRefresh] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  // Add/Edit dialog state
  const [formOpen, setFormOpen] = useState(false);
  const [formMode, setFormMode] = useState("add");
  const [editId, setEditId] = useState(null);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [formLoading, setFormLoading] = useState(false);
  // Delete button click handler
  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setDeleteDialog(true);
  };

  // Close dialog
  const handleCloseDialog = () => {
    setDeleteDialog(false);
    setDeleteId(null); // reset selected id
  };

  const handleAddClick = () => {
    setFormMode("add");
    setEditId(null);
    setStartTime("");
    setEndTime("");
    setFormOpen(true);
  };

  const handleEditClick = (id, start, end) => {
    setFormMode("edit");
    setEditId(id);
    setStartTime(start || "");
    setEndTime(end || "");
    setFormOpen(true);
  };

  const handleCloseForm = () => {
    setFormOpen(false);
    setFormLoading(false);
    setStartTime("");
    setEndTime("");
    setEditId(null);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (!startTime.trim()) return toast.error("Start time cannot be empty");
    if (!endTime.trim()) return toast.error("End time cannot be empty");
    setFormLoading(true);
    if (formMode === "add") {
      axios
        .post(`${baseURL}/slots`, { startTime, endTime })
        .then((res) => {
          toast.success(res.data?.message || "Timeslot added successfully");
          setRefresh((p) => !p);
          handleCloseForm();
        })
        .catch((err) => toast.error(err.response?.data?.error || "Failed to add timeslot"))
        .finally(() => setFormLoading(false));
    } else {
      axios
        .put(`${baseURL}/slots/${editId}`, { startTime, endTime })
        .then((res) => {
          toast.success(res.data?.message || "Timeslot updated successfully");
          setRefresh((p) => !p);
          handleCloseForm();
        })
        .catch((err) => toast.error(err.response?.data?.error || "Failed to update timeslot"))
        .finally(() => setFormLoading(false));
    }
  };

  const handleConfirmDelete = () => {
    axios
      .put(`${baseURL}/slots/${deleteId}`, { isDeleted: true })
      .then((res) => {
        console.log("✅ Slots deleted:", res.data);
        toast.success(res.data?.message);
        setRefresh((prev) => !prev);
        handleCloseDialog();
      })
      .catch((err) => {
        toast.error(err.response?.data?.error || "Failed to delete subject");
        console.error("❌ Error deleting subject:", err);
      });
  };

  const { columns, rows, count } = TimeSlotTableData(handleDeleteClick, handleEditClick, refresh);

  return (
    <ArgonBox>
      <ArgonBox display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <ArgonTypography variant="h6" size="small">
          All Timeslot
        </ArgonTypography>
        <ArgonButton variant="contained" color="primary" size="small" onClick={handleAddClick}>
          Add Time
        </ArgonButton>
      </ArgonBox>
      <ArgonBox
        sx={{
          "& .MuiTableRow-root:not(:last-child)": {
            "& td": {
              borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                `${borderWidth[1]} solid ${borderColor}`,
            },
          },
        }}
      >
        <Table columns={columns} rows={rows} />
      </ArgonBox>

      <DeleteDialog
        open={deleteDialog}
        onClose={handleCloseDialog}
        onConfirm={handleConfirmDelete}
        title="Delete Timeslot"
        description="Are you sure you want to delete this timeslot?"
        confirmText="Delete Timeslot"
        cancelText="Cancel"
      />

      {/* Add/Edit Timeslot Dialog */}
      <Dialog open={formOpen} onClose={handleCloseForm} maxWidth="sm" fullWidth>
        <DialogTitle>
          <ArgonBox display="flex" justifyContent="space-between" alignItems="center">
            <ArgonTypography variant="h5">
              {formMode === "add" ? "Add Timeslot" : "Edit Timeslot"}
            </ArgonTypography>
            <IconButton onClick={handleCloseForm} size="small">
              <Close />
            </IconButton>
          </ArgonBox>
        </DialogTitle>
        <Divider />
        <form onSubmit={handleFormSubmit}>
          <DialogContent>
            <ArgonBox display="flex" gap={2}>
              <ArgonBox
                component="input"
                type="time"
                value={startTime}
                onChange={(e) => setStartTime(e.target.value)}
                disabled={formLoading}
                sx={{
                  flex: 1,
                  padding: "10px 12px",
                  border: "1px solid #d2d6da",
                  borderRadius: "8px",
                }}
              />
              <ArgonBox
                component="input"
                type="time"
                value={endTime}
                onChange={(e) => setEndTime(e.target.value)}
                disabled={formLoading}
                sx={{
                  flex: 1,
                  padding: "10px 12px",
                  border: "1px solid #d2d6da",
                  borderRadius: "8px",
                }}
              />
            </ArgonBox>
          </DialogContent>
          <DialogActions>
            <ArgonButton
              onClick={handleCloseForm}
              variant="outlined"
              color="secondary"
              disabled={formLoading}
            >
              Cancel
            </ArgonButton>
            <ArgonButton type="submit" variant="contained" color="primary" disabled={formLoading}>
              {formMode === "add"
                ? formLoading
                  ? "Adding..."
                  : "Add Time"
                : formLoading
                ? "Updating..."
                : "Update Time"}
            </ArgonButton>
          </DialogActions>
        </form>
      </Dialog>
    </ArgonBox>
  );
}

export default index;
